module.exports = __webpack_public_path__ + "static/media/scheduled_delivery.5e886ead.mp3";